import { DownloadButton } from "@ugitgud/legos/ui/form/button/DownloadButton";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgArrowLineRight } from "@ugitgud/legos/ui/icon/SVG/ArrowLineRight";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";

export const REMATCH_BANNER_CTA = "app-rematch";

interface HighlightsBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function RematchBanner(props: HighlightsBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;

  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        className,
        `
          h-[48px] relative px-[8px] sm:px-[12px] w-full
          bg-[url('https://static.bigbrain.gg/assets/ugg/cta/rematch-img-bg.jpg')]
          bg-no-repeat
          bg-[#4747B5]
          bg-[position:calc(50%_-_200px)_center]
          md:bg-[position:calc(50%_-_380px)_center]
        `,
      )}
    >
      <div
        className={classNames("flex items-center relative justify-between xs:justify-center gap-2 xs:gap-[18px] h-full", {
          "pr-8 xs:pr-0": onClose,
        })}
      >
        <div className="flex-shrink-0">
          <img
            src="https://static.bigbrain.gg/assets/ugg/cta/rematch-logo.png"
            alt="Rematch Logo"
            className="h-[30px] xs:h-[36px] w-auto"
          />
        </div>
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
          <div className="font-bold text-[12x] xs:text-[18px] text-white">
            <span className="!font-barlow-condensed capitalize">
              <span className="text-[#00dfa9]">NEW!</span> Rematch Stats & Profiles
            </span>
          </div>
          <div className="font-inter font-medium text-[10px] xs:text-[12px] text-white">Track your career with U.GG</div>
        </div>
        <div
          className="flex items-center justify-between h-[30px] bg-[#00ad84] rounded-sm py-1.5 xs:py-2.5 pl-2 xs:pl-3 pr-1 cursor-pointer hover:bg-[#00ad84]/80 whitespace-nowrap"
          onClick={onUrlClick}
        >
          <span className="font-bold text-[10px] xs:text-[11px]">Check it out</span>
          <Icon icon={<SvgArrowLineRight />} className="w-5 h-5 xs:w-6 xs:h-6 text-white" />
        </div>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-50 z-[1]"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
